import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type { PaginationDto } from "@/models/dto/pagination.dto";
import type { PaginatedResponse } from "@/models/responses/base/baseResponse.response";
import type { Employee } from "@/models/responses/employees/employees.response";

const EmployeesService = {
  getEmployeesCount: async function () {
    const response = await api.get(ENDPOINTS.EMPLOYEES.COUNT);
    return response;
  },

  getEmployeesList: async function (dto: PaginationDto): Promise<PaginatedResponse<Employee>> {
    // Api interceptor already returns response.data, so the backend body { data, pagination } is what we get
    const response = await api.get(ENDPOINTS.EMPLOYEES.LIST, { params: dto });
    return response as unknown as PaginatedResponse<Employee>;
  },
};

export default EmployeesService;
